import React from 'react';
import './LegalPage.css';

const ReturnsPage: React.FC = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Returns Policy</h1>
        <p className="last-updated">Last Updated: July 28, 2026</p>

        <section>
          <h2>Returns</h2>
          <p>
            I want you to love your purchase. If something isn't right, I accept returns within 14 days of delivery.
          </p>
          <p>
            To start a return, just send me an email at <a href="mailto:micahdadson@yahoo.com">micahdadson@yahoo.com</a> with
            your order number and what's going on. All returns require prior approval so I can help
            resolve the issue and provide return instructions.
          </p>
        </section>

        <section>
          <h2>Conditions</h2>
          <ul>
            <li>Items must be unused, in original packaging, and in the same condition you received them.</li>
            <li>Return shipping is the responsibility of the customer unless the item arrived damaged or defective.</li>
            <li>Refunds are processed within 1–3 business days after I receive the returned item.</li>
          </ul>
        </section>

        <section>
          <h2>Non-Returnable Items</h2>
          <ul>
            <li><strong>Original paintings:</strong> All sales final. Original artwork is sold as-is.</li>
            <li><strong>Opened body care products:</strong> For hygiene reasons, opened items cannot be returned.</li>
          </ul>
        </section>

        <section>
          <h2>Damaged or Defective Items</h2>
          <p>
            If something arrives damaged or not quite right, please reach out within 48 hours with a photo
            and I'll make it right — whether that's a replacement or a full refund including return shipping.
          </p>
        </section>
      </div>
    </div>
  );
};

export default ReturnsPage;
